/* eslint-disable @typescript-eslint/no-explicit-any */
import { Reducer } from 'redux';
import { sceneMatchingSaga } from './sagas';
import sceneMatchingSlice, { SCENE_MATCHING_KEY_IN_STORE } from './slice';

export class SceneMatchingModule {
	getRootKeyInStore(): string {
		return SCENE_MATCHING_KEY_IN_STORE;
	}

	getReducers(): Reducer {
		return sceneMatchingSlice.reducer;
	}

	getSagas(): () => Generator<any, void, any> {
		return sceneMatchingSaga;
	}
}

export const moduleInstance = new SceneMatchingModule();
